import React from 'react'
import { CircularProgress } from '@material-ui/core'

export default (props) => {
  //Props from MUI
  return <CircularProgress {...props} />
}
